import { ComponentProps } from "."
import { Avatar, Content, Subtitle, Title, Wrapper } from "./styled"

const Header = ({ avatar, subheader, title }: ComponentProps) => (
  <Wrapper>
    <Avatar aria-label={`${title} Avatar`}>{avatar}</Avatar>

    <Content>
      <Title> {title}</Title>

      <Subtitle>{subheader}</Subtitle>
    </Content>
  </Wrapper>
)

export default Header
